// extracted by mini-css-extract-plugin
module.exports = {"card-description-datagrid":"CardListDatagrid_card-description-datagrid__3TCbD"};